import { render, staticRenderFns } from "./TimeFrameSlices.vue?vue&type=template&id=38099d14&scoped=true&"
import script from "./TimeFrameSlices.vue?vue&type=script&lang=js&"
export * from "./TimeFrameSlices.vue?vue&type=script&lang=js&"
import style0 from "./TimeFrameSlices.vue?vue&type=style&index=0&id=38099d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38099d14",
  null
  
)

export default component.exports